module.exports = __webpack_public_path__ + "static/img/fha-logo.54cc7e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/web/assets/fha-logo.jpg
// module id = 104
// module chunks = 0